import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { NumberFormatText } from "../../../../components/NumberFormatText";
import { RowBody } from "../../../../components/RowValue/RowBody";
import { ResultSpan } from "../../../../components/styledComponents/Result";
import { selectUtilization } from "../../../../store/slices/aashtoSlice.js";

function Utilization() {
  const { t } = useTranslation("translation");

  const utilization = useSelector(selectUtilization);
  let isValid = utilization <= 1;

  return (
    <RowBody
      titleValue={<p>{t("aashto.inner.Utilization")}</p>}
      inputValue={
        <ResultSpan valid={isValid}>
          <NumberFormatText value={utilization} decimalScale={2} />
        </ResultSpan>
      }
    />
  );
}

export default Utilization;
